// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { get } from 'crm_data/api/ImmutableAPI';
const HAS_EMAIL_ENGAGEMENTS_URI = 'engagements/v1/engagements/has-associated-email';
export function fetch(objectType, subjectId) {
  const url = `${HAS_EMAIL_ENGAGEMENTS_URI}/${objectType}/${subjectId}`;
  return get(url);
}